var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.714,
    height: 27.707,
    viewBox: "0 0 27.714 27.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471",
    transform: "translate(0.009 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M23.648,23.648a13.857,13.857,0,1,0-19.6,0,13.857,13.857,0,0,0,19.6,0ZM5.029,5.029a12.475,12.475,0,1,1,0,17.642,12.475,12.475,0,0,1,0-17.642Z",
    fill: "#ee4e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M160.9,167.941a1,1,0,0,0,.694-.287.983.983,0,0,0,.287-.694v-5.367h5.367a1,1,0,0,0,.694-.287.983.983,0,0,0,.287-.694.967.967,0,0,0-.973-.973h-5.367v-5.367a.973.973,0,1,0-1.946,0v5.367h-5.367a.973.973,0,1,0,0,1.946h5.367v5.367a.948.948,0,0,0,.957.989Z",
    transform: "translate(-147.047 -146.77)",
    fill: "#ee4e56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.deca9f28b62f33defd968af8988478b7.svg";
export { ForwardRef as ReactComponent };